import { render, staticRenderFns } from "./OptimizationReviews.vue?vue&type=template&id=a4cb27c4&scoped=true"
import script from "./OptimizationReviews.vue?vue&type=script&lang=ts"
export * from "./OptimizationReviews.vue?vue&type=script&lang=ts"
import style0 from "./OptimizationReviews.vue?vue&type=style&index=0&id=a4cb27c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb27c4",
  null
  
)

export default component.exports